import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiHeroSectionDTO,
  HeroSectionDTO,
} from "@lib/strapi/dtos/components/sections/heroSection.dto";
import { getImageProps, ImageProps } from "@lib/image";
import { LinkService } from "@lib/strapi/services/components/shared/link.service";

export class HeroSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiHeroSectionDTO,
  ): Promise<HeroSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new HeroSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.style = strapiData.style;
    dto.heading = strapiData.heading;
    dto.subheading = strapiData.subheading;
    dto.image = getImageProps(strapiData.image);
    dto.links = await Promise.all(
      (strapiData.links ?? []).map(
        async (item) => await LinkService.fromStrapi(locale, item),
      ),
    );
    dto.showPhoneCta = strapiData.showPhoneCta;
    return dto;
  }
}
